export default __webpack_public_path__ + "images/4b024635cf25b963f90828af92538d1f-comedy.webp";